const { version } = require('../package.json');

export default version;
